(function () {
  // The section's script_tag has no defer, so this file executes during parse
  // — BEFORE the section exists in the DOM. Every querySelectorAll came back
  // empty and the whole file silently no-oped in real browsers (drawer toggle
  // included; found via the compact bar, 2026-08-02 PM). Bind at readiness.
  const init = () => {
  const sections = document.querySelectorAll('[data-header-component]');
  if (!sections.length) return;

  sections.forEach((section) => {
    const toggles = section.querySelectorAll('[data-header-toggle]');
    const drawer = section.querySelector('[data-header-drawer]');
    const close = section.querySelector('[data-header-close]');
    if (!toggles.length || !drawer) return;

    const open = () => {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };

    const shut = () => {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    toggles.forEach((t) => t.addEventListener('click', open));
    if (close) close.addEventListener('click', shut);

    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) shut();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') shut();
    });
  });

  /**
   * Keep the header cart count in sync with the cart.
   * The drawer re-renders via hydration morph (which only touches
   * [data-hydration-key] nodes), so the count badge — which lives outside the
   * drawer — must be updated here. Fires on add-to-cart and quantity changes.
   */
  const applyCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = String(count);
      el.classList.toggle('is-empty', Number(count) === 0);
    });
  };

  document.addEventListener('cart:update', (event) => {
    const cart = event && event.detail ? event.detail.resource : null;
    if (cart && typeof cart.item_count === 'number') {
      applyCount(cart.item_count);
    } else {
      fetch('/cart.js')
        .then((r) => r.json())
        .then((c) => applyCount(c.item_count))
        .catch(() => {});
    }
  });

  // Compact bar: reveal on scroll-up (the editorial melt, 2026-08-02).
  // Hidden while reading down; scrolling back up melts it in once the full
  // masthead is off-screen. Reduced-motion gets the instant swap via CSS.
  sections.forEach((section) => {
    section.querySelectorAll('.ah-nav-item--mega').forEach((item) => {
      const mega = item.querySelector('[data-mega-panel]');
      if (!mega) return;
      let closeTimer = null;
      const open = () => {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        mega.classList.add('is-open');
      };
      const close = () => {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(() => { mega.classList.remove('is-open'); closeTimer = null; }, 350);
      };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      mega.addEventListener('mouseenter', open);
      mega.addEventListener('mouseleave', close);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') mega.classList.remove('is-open'); });
    });
  });
  // Piece-intent memory (Kevin 8/10): a Workroom mega piece-tile click is a
  // declaration of the piece the client wants — remember it so the world-card
  // configurator opens preset when they later pick a cloth.
  // ATELIER_INTENT_CONTRACT — localStorage['asthetik:atelier:v1'].intent =
  //   { treatment: drapery|cafe|roman|valance,
  //     construction: house|pinch|tailored|euro|box|grommet (optional),
  //     ts: epoch ms }.
  // Writers: this handler, drapery-atelier.liquid pleat choices,
  // atelier-cloth-browser.liquid tiles. Reader: lucie-hero-page.liquid
  // bootPreset (?treatment=/?construction= params override; 7-day TTL).
  // Delegated on document — the mega snippet can render more than once per
  // page (one per mega nav_item), so per-node binding is the wrong shape.
  document.addEventListener('click', (e) => {
    const tile = e.target && e.target.closest ? e.target.closest('.ah-mega-piece[data-piece]') : null;
    if (!tile) return;
    try {
      const key = 'asthetik:atelier:v1';
      let o = JSON.parse(window.localStorage.getItem(key) || 'null');
      o = (o && typeof o === 'object') ? o : {};
      const it = (o.intent && typeof o.intent === 'object') ? o.intent : {};
      it.treatment = tile.getAttribute('data-piece');
      it.ts = Date.now();
      o.intent = it;
      o.v = 1;
      window.localStorage.setItem(key, JSON.stringify(o));
    } catch (err) { /* storage unavailable — the click is plain navigation */ }
  });

  sections.forEach((section) => {
    const bar = section.querySelector('[data-compact-bar]');
    if (!bar) return;
    let lastY = window.scrollY;
    let ticking = false;
    // The body class mirrors the bar's state so page-level chrome (the
    // window page's chapter spine) can move as one block with it.
    const setShown = (on) => {
      bar.classList.toggle('is-shown', on);
      document.body.classList.toggle('ah-compact-shown', on);
    };
    const update = () => {
      ticking = false;
      const y = window.scrollY;
      const past = y > section.offsetHeight + 120;
      if (past && y < lastY - 2) setShown(true);
      else if (!past || y > lastY + 2) setShown(false);
      lastY = y;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
  });

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
